import moment from 'moment';
import { ModelBase } from '../abstract/model-base.model';
import { ConversationItemTypeEnum } from '../../enums/conversation-item-type.enum';
import { Person } from '../person/abstract/person.model';
import { File } from '../file/file.model';
import { ClientContact } from '../client/contact.model';
import { PartnerContact } from '../partner/contact.model';

export class ConversationItem extends ModelBase {

    static override CLASS_NAME: string = 'ConversationItem';

    private _attachments!: File[];
    private _author!: Person;
    private _content!: string;
    private _emailInAddress!: string;
    private _mentionsExternal!: PartnerContact[];
    private _mentionsInternal!: ClientContact[];
    private _messageDatetime!: moment.Moment;
    private _type!: string;

    public constructor(data?: any) {
        super(data);
        this._mentionsExternal = this.mentionsExternal || [];
        this._mentionsInternal = this.mentionsInternal || [];
    }

    public get attachments(): File[] {
        return this._attachments;
    }

    public set attachments(value: any) {
        this._setValue('_attachments', value, 'File');
    }

    public get author(): Person {
        return this._author;
    }

    public set author(value: any) {
        this._setValue('_author', value, 'Person');
    }

    public get content(): string {
        return this._content;
    }

    public set content(value: any) {
        this._setValue('_content', value, 'string');
    }

    public get emailInAddress(): string {
        return this._emailInAddress;
    }

    public set emailInAddress(value: any) {
        this._setValue('_emailInAddress', value, 'string');
    }

    public get icon(): string {
        switch (true) {
            case this._type === ConversationItemTypeEnum.Email:
                return 'fa-solid fa-envelope';
            case this._type === ConversationItemTypeEnum.InApp:
                return 'fa-solid fa-user';
            case this._type === ConversationItemTypeEnum.System:
                return 'fa-solid fa-cog';
            default:
                return '';
        }
    }
    public get isEmail(): boolean {
        return this._type === ConversationItemTypeEnum.Email;
    }

    public get isSystem(): boolean {
        return this._type === ConversationItemTypeEnum.System;
    }

    public get mentionsExternal(): PartnerContact[] {
        return this._mentionsExternal;
    }

    public set mentionsExternal(value: any) {
        this._setValue('_mentionsExternal', value, 'PartnerContact');
    }

    public get mentionsInternal(): ClientContact[] {
        return this._mentionsInternal;
    }

    public set mentionsInternal(value: any) {
        this._setValue('_mentionsInternal', value, 'ClientContact');
    }

    public get messageDatetime(): moment.Moment {
        return this._messageDatetime;
    }

    public set messageDatetime(value: any) {
        this._setValue('_messageDatetime', value, 'datetime');
    }

    public get type(): string {
        return this._type;
    }

    public set type(value: any) {
        this._setValue('_type', value, 'string');
    }

}
